'use strict';
import URLJoin from 'url-join';
import React from 'react';
import { TweenMax, TimelineMax, EasePack, TextPlugin} from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Recaptcha from 'react-google-recaptcha';
import settings from '../../util/settings';
import InputField from '../../components/InputField/InputField';
import TextArea from '../../components/TextArea/TextArea';
import fetch from 'isomorphic-fetch';
import ReactGA from 'react-ga';
import ParticleEffectButton from 'react-particle-effect-button'
import Button from '../../components/Button/Button';
import Title from '../../components/Title/Title';
import fa from '@fortawesome/fontawesome';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import SolidIcons from '@fortawesome/fontawesome-free-solid'

class Contact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validCaptcha: false,
      showError: false,
      email: {
        submitted: false,
        sent: false,
        failed: false
      },
      analyticsSubmitted: {
        scroll: false,
        form: false
      },
      btn: {
        hidden: false,
        animating: false
      }
    }
    this.AnimationElements = []
    this.InputFields = []
  }
  componentDidMount() {
    TweenMax.to(this.container, 0.5, {autoAlpha: 1});
    TweenMax.set(this.AnimationElements, {autoAlpha: 0});
    this.animateIn();

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll()
    this.props.refSetter(this.container, this.props.refOrder)
    fa.library.add(SolidIcons);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    TweenMax.set(this.container, {autoAlpha: 0});
  }
  getIcon = (icon) => {
    return fa.findIconDefinition({iconName: icon})
  }
  handleInputChange = (e, item)=>{

  }
  handleScroll = (e) => {
    if (this.container.getBoundingClientRect().top < window.innerHeight && !this.state.analyticsSubmitted.scroll) {
      ReactGA.modalview('contact');
      this.setAnalyticSubmission('scroll')
    }
    if (this.props.isResponsive) {
      if (this.container.getBoundingClientRect().top <= window.innerHeight/2) {
        this.animateIn();
        window.removeEventListener('scroll', this.handleScroll);
      }
    } else {
      if (this.container.getBoundingClientRect().top < window.innerHeights) {
        this.animateIn();
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  }
  setAnalyticSubmission = (name) => {
    if (name) {
      this.setState({analyticsSubmitted: {...this.state.analyticsSubmitted, [name]: true}})
    }
  }
  animateIn = () => {
    var tl = new TimelineMax({paused: true});
    tl.staggerFromTo(this.AnimationElements, 2, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Expo.easeOut}, 0.25);
    tl.play();
  }
  handleReCaptcha = (value) => {
    this.setState({
      validCaptcha: value
    })
  }
  handleSubmit = (e) => {
    e.preventDefault();
    var allValid = true;
    for (var i = 0; i < this.InputFields.length; i++) {
      if (this.InputFields[i].id !== "website") {
        if (!this.InputFields[i].state.valid) {
          allValid = false;
          break;
        }
      }
    }
    if (!allValid) {
      this.setState({showError: true})
    } else if (!this.state.validCaptcha && !settings.isDev) {
      this.setState({showError: true})
    } else {
      fetch(URLJoin(settings.server, 'forms', 'mail.php'), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          "Content-type": "application/x-www-form-urlencoded"
        },
        body: JSON.stringify(this.getFormContent())
      }).then((response) => {
        if (!response.ok) {
          throw new Error('Something went wrong');
        } else {
          this.setState({ email: { sent: true } })
        }
        ReactGA.event({
          category: 'Contact',
          action: 'Submit',
          label: response.ok ? 'Succeeded' : 'Failed'
        });
        return response.json();
      }).then((data)=>{
        // console.log(data)
      }).catch(msg => {
        this.setState({email: {...this.state.email, failed: true}})
        this.toggleButton()
      })
      this.toggleButton()
    }
  }
  getFormContent = () => {
    var obj = {};
    for (var i = 0; i < this.InputFields.length; i++) {
      obj[this.InputFields[i].props.id] = this.InputFields[i].state.value
    }
    return obj;
  }

  toggleButton = () => {
    if (this.state.btn.animating) return
    this.setState({btn: {
      hidden: !this.state.btn.hidden,
      animating: true
    }})
  }

  onBtnAnimComplete = () => {
    this.setState({btn: {
      ...this.state.btn, animating: false
    }, email: {...this.state.email, submitted: this.state.btn.hidden ? true : false}})
  }

  resetForm = () => {
    this.setState({email: {...this.state.email, submitted: false, sent: false, failed: false}});
    window.setTimeout(this.toggleButton, 1000);
  }

  render() {
    this.AnimationElements = []
    this.InputFields = []

    return <div
      id="section-contact"
      ref={el => this.container = el}
    >
      {/* Background Envelope SVG */}
      {/* <div id="envelope-svg">
        <svg width="23.708in" height="12.5in" viewBox="0 0 1100 1280">
          <g>
            <path fillRule="evenodd"  fill="#e6e6e6"
             d="M270.693,1270.119 L9.840,474.971 L1441.621,4.904 L1702.473,800.051 L270.693,1270.119 Z"/>
          </g>
          <g>
            <path fillRule="evenodd"  fill="#f9f9f9"
             d="M1706.019,801.836 C1706.019,801.836 1075.785,584.459 979.470,552.542 C797.319,507.563 830.732,499.559 710.049,643.961 C620.926,766.609 264.863,1274.981 264.863,1274.981 L1706.019,801.836 Z"/>
          </g>
          <g>
            <path fillRule="evenodd"  fill="#f3f3f3"
             d="M0.977,473.218 C0.977,473.218 641.440,682.983 737.777,714.929 C919.968,759.956 882.037,772.409 1002.724,627.945 C1091.848,505.242 1442.343,0.003 1442.343,0.003 L0.977,473.218 Z"/>
          </g>
        </svg>
      </div> */}
      <div className="ContentContainer">
        <Title title="CONTACT" subtitle="Have any questions? Connect with us and let us help!" />
        <div className="row">
          <div className="col-md-5 contact-info">
            <div className="row">
              <div className="icon pushedDown">
                <FontAwesomeIcon icon={this.getIcon("map-marker-alt")} />
              </div>
              <div className="info">
                <a href="https://www.google.ca/maps/place/124+Connie+Crescent,+Concord,+ON+L4K+1L3/@43.8206287,-79.4923585,15.9z/" target="_blank">124 Connie Cres, #10<br/>Vaughan, ON<br/>L4K 1L7</a>
              </div>
            </div>
            <div className="row">
              <div className="icon">
                <FontAwesomeIcon icon={this.getIcon("envelope")} />
              </div>
              <div className="info">
                <a href="mailto:sales@metalsalloyscentre.com">sales@metalsalloyscentre.com</a>
              </div>
            </div>
            <div className="row">
              <div className="icon mirrored">
                <FontAwesomeIcon icon={this.getIcon("phone")} />
              </div>
              <div className="info">
                <a href="tel:+19056603386">(905) 660 - 3386</a>
              </div>
            </div>
            <div className="row">
              <div className="icon pushedDown">
                <FontAwesomeIcon icon={this.getIcon("clock")} />
              </div>
              <div className="info">
                <p className="days">Monday - Friday</p>
                <p className="hours">8:00am - 5:00pm</p>
                <p className="days">Saturday</p>
                <p className="hours">8:00am - 1:00pm</p>
                <p className="days">Sunday</p>
                <p className="hours">Closed</p>
              </div>
            </div>
            <div className="row">
              <div className="info col-10">
                <p>We are open to the public.<br/>Accepting payments in Interac, Visa and MasterCard.</p>
              </div>
            </div>
          </div>
          <div className="col-md-7" style={{maxWidth: 600}}>
            {
              !this.state.email.submitted ? (
                <form onSubmit={this.handleSubmit}>
                  {/* InputFields */}
                  <div className="row" ref={el => this.AnimationElements[0] = el}>
                    <div className="col-12">
                      <InputField label="Name" id="name" /*icon="user"*/
                                  showError={this.state.showError} ref={el => this.InputFields[0] = el}
                                  onChange={this.handleInputChange} isRequired />
                    </div>
                  </div>
                  <div className="row" ref={el => this.AnimationElements[1] = el}>
                    <div className="col-12">
                      <InputField label="Email" id="email" isRequired type="email" /*icon="envelope"*/
                                  showError={this.state.showError} ref={el => this.InputFields[1] = el} />
                    </div>
                  </div>
                  <div className="row" ref={el => this.AnimationElements[2] = el}>
                    <div className="col-12">
                      <InputField label="Phone (optional)" id="phone" type="phone" /*icon="phone"*/ mirrored
                                  showError={this.state.showError} ref={el => this.InputFields[2] = el} />
                    </div>
                  </div>
                  {/* TextArea */}
                  <div className="row" ref={el => this.AnimationElements[3] = el}>
                    <div className="col-12">
                      <TextArea label="How can we help you?" id="message" /*icon="comments"*/
                                isRequired showError={this.state.showError}
                                onChange={this.handleInputChange} ref={el => this.InputFields[3] = el}/>
                    </div>
                  </div>
                  <div ref={el => this.AnimationElements[4] = el}>
                    { !settings.isDev &&
                      <div>
                        <Recaptcha
                          key="captcha"
                          className="captcha"
                          onChange={this.handleReCaptcha}
                          sitekey={settings.googleReCaptchaKey}
                          theme="dark"
                        />
                        <h6 style={{color: "red", marginTop: 10}} className="thin">{this.state.showError && !this.state.validCaptcha ? "Please complete the reCAPTCHA" : ""}</h6>
                      </div>
                    }
                  </div>
                  <div ref={el => this.AnimationElements[5] = el}>
                    <ParticleEffectButton
                        color={settings.colors.secondary}
                        hidden={this.state.btn.hidden}
                        onComplete={()=>{this.onBtnAnimComplete()}}>
                      {
                        // <button className="btn-styled">SEND</button>
                      }
                      <Button title="SEND" onWhite action={this.handleSubmit} style={{paddingLeft: 50, paddingRight: 50}}/>
                    </ParticleEffectButton>
                  </div>
                </form>
              ) : (
                <div className="row">
                  <div className="col-12">
                    { this.state.email.sent &&
                      <h4>Thanks for your email, we will get back to you shortly.</h4>
                    }
                    { this.state.email.failed && (
                      <div className="col-md-10">
                        <h4>Sorry, there was an error sending your email.Please try again later.</h4>
                        <button className="btn-styled" style={{marginTop: 30}} onClick={this.resetForm}>TRY AGAIN</button>
                      </div>
                    )
                    }
                    { !this.state.email.sent && !this.state.email.failed &&
                      <h2>Sending email...</h2>
                    }
                  </div>
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>;
  }
};

Contact.defaultProps = {
  windowWidth: 960,
  windowHeight: 570
};

export default Contact;



// WEBPACK FOOTER //
// ./sections/Contact/Contact.js